import React from 'react';
import ChatIntegrated from '../ChatIntegrated';

const RightSidebar = ({
  showRightSidebar,
  rightColumnWidth,
  isResizing,
  handleMouseDown,
  idea,
  id,
  components,
  setComponents,
  refreshSidebar
}) => {
  return (
    <div 
      className={`hidden lg:flex flex-col relative h-full min-h-0 transition-all duration-300 ease-in-out overflow-hidden ${
        showRightSidebar ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full pointer-events-none'
      }`}
      style={{ 
        width: showRightSidebar ? `${rightColumnWidth}px` : '0px',
        minWidth: showRightSidebar ? `${rightColumnWidth}px` : '0px'
      }}
    >
      {/* Resize handle */}
      <div
        className={`absolute left-0 top-0 bottom-0 w-3 cursor-col-resize group flex items-center justify-center z-20 transition-colors pointer-events-auto ${
          isResizing ? 'bg-[var(--primary)]/20' : 'hover:bg-[var(--bg-hover)]'
        }`}
        onMouseDown={handleMouseDown}
        title="Drag to resize"
      >
        <div className={`w-0.5 h-16 rounded-full transition-all duration-200 ${
          isResizing 
            ? 'bg-[var(--primary)] w-1 h-24 shadow-lg' 
            : 'bg-[var(--border)] group-hover:bg-[var(--primary)] group-hover:h-20'
        }`} />
        {/* Add dots for better visual feedback */}
        <div className="absolute inset-0 flex flex-col items-center justify-center space-y-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-0.5 h-0.5 bg-[var(--text-secondary)] rounded-full"></div>
          <div className="w-0.5 h-0.5 bg-[var(--text-secondary)] rounded-full"></div>
          <div className="w-0.5 h-0.5 bg-[var(--text-secondary)] rounded-full"></div>
        </div>
      </div>
      
      {/* Content wrapper with proper padding */}
      <div className="flex-1 flex flex-col pl-4 pr-3 overflow-hidden">
        {/* Info Section */}
        <div className="p-6 bg-[var(--bg-secondary)] rounded-lg mb-6">
          <div className="space-y-3 text-sm">
            <div>
              <span className="text-[var(--text-secondary)]">Status:</span>
              <span className="ml-2 text-[var(--text-primary)] capitalize">{idea && idea.status}</span>
            </div>
            <div>
              <span className="text-[var(--text-secondary)]">Created at:</span>
              <span className="ml-2 text-[var(--text-primary)]">
                {idea && new Date(idea.created_at).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
        
        {/* Chat Section */}
        <div className="flex-1 mb-6 min-h-0 flex flex-col justify-end">
          <ChatIntegrated 
            ideaId={id} 
            components={components} 
            setComponents={setComponents} 
            refreshSidebar={refreshSidebar} 
            mode="integrated" 
          />
        </div>
      </div>
    </div>
  );
};

export default RightSidebar;
